import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-48036de2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ct-header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "vue logo"
  }),
  /*#__PURE__*/_createElementVNode("p", null, "Vue Doc Editor")
], -1))
const _hoisted_2 = { class: "theme" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", {
        id: "theme_handler",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click-theme')))
      }, _toDisplayString(_ctx.theme === "light" ? "dark" : "light"), 1)
    ])
  ]))
}